import { useEffect, useRef } from 'react';

type DocusignSenderViewProps = {
  url: string;
  onEvent: (event: string) => void;
};

export const DocusignSenderView = ({
  url,
  onEvent,
}: DocusignSenderViewProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    let docusignOrigin: string | null = null;
    try {
      docusignOrigin = new URL(url).origin;
    } catch {
      docusignOrigin = null;
    }
    const callbackOrigin = window.location.origin;

    const handleMessage = (event: MessageEvent) => {
      const isFromDocusign = docusignOrigin != null && event.origin === docusignOrigin;
      const isFromCallbackPage = event.origin === callbackOrigin;
      if (!isFromDocusign && !isFromCallbackPage) return;

      const data = event.data;
      if (
        data &&
        typeof data === 'object' &&
        data.type === 'docusign-event' &&
        typeof data.event === 'string'
      ) {
        onEvent(data.event);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [url, onEvent]);

  return (
    <iframe
      ref={iframeRef}
      src={url}
      className="w-full h-full min-h-0 border-0 flex-1"
      title="DocuSign Sender View"
      allow="forms"
    />
  );
};
